(() => {
  const movePersonalMessageToEnd = (scope = document) => {
    scope.querySelectorAll('.cart-items tbody').forEach((body) => {
      const personalMessage = body.querySelector('.mb-personal-message-line');
      if (personalMessage && personalMessage !== body.lastElementChild) body.append(personalMessage);
    });
  };

  const init = () => {
    movePersonalMessageToEnd();
    const cart = document.getElementById('main-cart-items');
    if (!cart) return;
    new MutationObserver(() => movePersonalMessageToEnd(cart)).observe(cart, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
